<template>
    <div class="animation-screen">
        <div class="animation-screen__wrapper">
            <component
                v-for="(actor, index) in actors"
                ref="actors"
                :key="actor.id"
                :is="actor.component"
                :style="{
                    top: actor.y + 'px',
                    left: actor.x + 'px',
                    transform: 'scale(' + actor.scale + ')',
                    opacity: actor.opacity,
                    zIndex: 1000 + index,
                }"
                :class="actor.class"
                v-bind="actor.componentProps"
            />
        </div>
    </div>
</template>

<script>
    import StartMessage from '@/components/spread/StartMessage';
    import style from '@/style/settings.scss';

    export default {
        data () {return {
            actors: [],  
        }},

        mounted () {
            // At times, mounted triggers before drawn html element have width and height.
            setTimeout(() => {
                this.$nextTick(() => {
                    this.$emit("mounted");
                })
            }, 100);
        },

        methods: {

            registerActor (conf) {
                let id = __id('ca');
                this.actors.push({
                    id, class: [], x: 0, y: 0, scale: 1,
                    ...conf
                });

                return id;
            },

            getActor (id) {
                return this.actors.find(a => a.id == id);
            },

            animeActor (id, steps=[], callback, autoDelete=true) {
                
                var actor = this.getActor(id);

                var iterator = steps[Symbol.iterator]();

                var _anime = (step) => {

                    if (typeof step.onStart === "function") step.onStart(actor);
                    
                    let opt = {
                        targets: actor,
                        easing: 'easeInQuad',
                        ...step,
                        complete: () => {
                            if (typeof step.onComplete === "function") step.onComplete(actor);
                            var nextStep = iterator.next();
                            if (typeof nextStep.onStart === "function") nextStep.onStart(actor);
                            if (!nextStep.done) _anime(nextStep.value);
                            else {
                                if (autoDelete) {
                                    this.remove(actor);
                                    if (typeof callback === "function") callback();
                                }
                                else {
                                    if (typeof callback === "function") callback(() => {
                                       this.remove(actor)
                                    });
                                }


                            }
                        }
                    };

                    anime(opt);
                };

                _anime(iterator.next().value);

            },

            // Register and anime actor
            anime (conf, steps=[], callback, autoDelete=true) {

                this.animeActor(
                    this.registerActor(conf),
                    steps, callback, autoDelete
                );

            },

            drawStartMessage () {
                let actor = {
                    id: 'sm',
                    component: StartMessage,
                    y: this.$el.offsetHeight/2 - 80,
                    opacity: 0,
                }
                this.actors.push(actor)

                // nextTick prevent opacity to bug
                // this.$nextTick(() => {
                    anime({
                        targets: actor,
                        duration: style.boardStartMessageTransition,
                        easing: 'easeInQuad',
                        opacity: 1,
                    })
                // });
            },

            remove (actor) {
                this.actors.splice(this.actors.indexOf(actor), 1)
            },

            removeStartMessage () {
                let actor = this.actors.find(a => a.id == 'sm')

                anime({
                    targets: actor,
                    duration: style.boardStartMessageTransition,
                    easing: 'easeInQuad',
                    opacity: 0,
                    complete: () => {
                        this.remove(actor)
                    }
                })
            },
        }
    }
</script>